import { CommonModule } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
    selector: 'dialog-spinner',
    templateUrl: './dialog-spinner.component.html',
    styleUrls: ['./dialog-spinner.component.scss'],
    standalone:true,
    imports:[CommonModule, MatProgressSpinnerModule]

})
export class DialogSpinner implements OnInit{
    msg: string;

    constructor(
        private dialogRef: MatDialogRef<DialogSpinner>,
        @Inject(MAT_DIALOG_DATA) data: any
    ){
        this.msg = data.msg;
    }

    ngOnInit(){}

}



